import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Outstationcabservicenavimumbai() {



const cardData = {
  keyword: " Outstation Cab Service Navi Mumbai",

headingDescription:
"Omshree Cab provides reliable and comfortable outstation cab services from Navi Mumbai for travelers seeking convenient, safe, and hassle-free transportation to destinations across Maharashtra and beyond. Whether you are planning a family trip, weekend getaway, business travel, or a spiritual pilgrimage, our outstation cab service ensures a smooth journey with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way trips, round trips, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs familiar with highways and long-distance routes, punctual pickups from anywhere in Navi Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for outstation cab bookings from Navi Mumbai.",

topPlaces: [
{
title: "Mahabaleshwar",
description:
"Mahabaleshwar is a popular hill station in the Western Ghats, known for its lush greenery, scenic viewpoints, strawberry farms, and waterfalls. Visitors can enjoy panoramic views from Arthur’s Seat, relax at Venna Lake, and explore Mapro Garden. Traveling by outstation cab from Navi Mumbai provides a comfortable and safe journey, allowing sufficient time to explore the hill station’s attractions without worrying about local transport or parking."
},
{
title: "Pune",
description:
"Pune is a vibrant city known for its historical landmarks, cultural heritage, shopping hubs, and delicious cuisine. Key attractions include Shaniwar Wada, Dagdusheth Ganpati Temple, and Koregaon Park. Using an outstation cab from Navi Mumbai ensures convenient, flexible, and comfortable travel for sightseeing, business meetings, or leisure activities."
},
{
title: "Lonavala and Khandala",
description:
"The twin hill stations of Lonavala and Khandala are famous for scenic landscapes, forts, waterfalls, and viewpoints such as Tiger’s Leap and Lion’s Point. Visitors can enjoy trekking, photography, and local snacks like chikki. Traveling by outstation cab from Navi Mumbai provides a hassle-free way to experience these popular destinations in comfort."
},
{
title: "Shirdi",
description:
"Shirdi is the holy town famous for the Sai Baba Temple, attracting pilgrims from across the country. Visitors can participate in prayers, rituals, and spiritual programs. An outstation cab from Navi Mumbai allows devotees to reach Shirdi comfortably and efficiently while ensuring safe travel."
},
{
title: "Nashik",
description:
"Nashik is renowned for its vineyards, religious sites like Trimbakeshwar Jyotirlinga, and scenic landscapes along the Godavari River. Tourists can enjoy wine tasting, temple visits, and riverfront walks. Outstation cab service from Navi Mumbai provides a convenient and comfortable way to explore Nashik without worrying about driving long distances."
},
{
title: "Kolhapur",
description:
"Kolhapur is a historic city known for the Mahalaxmi Temple, Kolhapuri chappals, and local cuisine. Visitors can explore temples, palaces, and cultural markets. Traveling by outstation cab from Navi Mumbai ensures a safe and relaxing journey while allowing enough time to enjoy the city’s attractions."
},
{
title: "Aurangabad",
description:
"Aurangabad is famous for the Ajanta and Ellora Caves, Bibi Ka Maqbara, and other historical sites. Tourists can explore UNESCO World Heritage Sites comfortably with an outstation cab from Navi Mumbai, making the journey smooth and time-efficient."
},
{
title: "Goa",
description:
"Goa is a premier beach destination known for its sandy shores, nightlife, Portuguese heritage, and spice plantations. Traveling by outstation cab from Navi Mumbai provides a convenient and safe option for long-distance trips, allowing tourists to enjoy the beaches and cultural attractions at their own pace."
},
{
title: "Pandharpur",
description:
"Pandharpur is a renowned pilgrimage town famous for the Vithoba Temple and attracts devotees throughout the year. An outstation cab from Navi Mumbai ensures comfortable and timely travel for pilgrims wishing to visit this spiritual destination and nearby holy sites like Akkalkot and Tuljapur."
},
{
title: "Bhimashankar",
description:
"Bhimashankar is a sacred Jyotirlinga site located in the Western Ghats, surrounded by lush forests and hills. Visitors can perform spiritual rituals and enjoy trekking and wildlife spotting. Traveling by outstation cab from Navi Mumbai provides safe and comfortable access to this remote but spiritually significant location."
}
],



services: [
{
name: "Outstation Cab Service Navi Mumbai",
description: "Outstation cab service Navi Mumbai provides reliable long-distance transportation for travelers planning trips outside the city. Passengers can comfortably travel to popular destinations like Pune, Nashik, Shirdi, Lonavala, Goa, and other cities across Maharashtra and India. Our fleet includes comfortable sedans, SUVs, and premium MPV vehicles suitable for long highway journeys. Professional drivers ensure safe driving and punctual pickups across Navi Mumbai areas. Vehicles offer spacious seating, powerful AC, and luggage space for relaxed travel. The service is ideal for family vacations, corporate travel, and pilgrimage trips. Travelers enjoy convenient and dependable intercity transportation."
},
{
name: "Navi Mumbai Outstation Cab",
description: "Navi Mumbai outstation cab service offers convenient transportation for travelers planning intercity and long-distance journeys. The cab provides comfortable seating and smooth ride quality suitable for highway travel. Professional drivers ensure safe driving and punctual pickup services from homes, offices, hotels, and railway stations in Navi Mumbai. The vehicles are well maintained with spacious interiors and strong air conditioning. Families and business travelers enjoy relaxed journeys to nearby cities and tourist destinations. The service is suitable for both one-way and round-trip travel. Customers receive reliable and comfortable transportation."
},
{
name: "Outstation Taxi Navi Mumbai",
description: "Outstation taxi Navi Mumbai provides dependable taxi transportation for travelers heading to destinations outside the city. The taxi service offers comfortable vehicles suitable for both short and long-distance travel. Professional drivers ensure safe driving and timely pickups across Navi Mumbai locations. Vehicles provide spacious seating and efficient AC cooling for comfortable journeys. The service is ideal for tourists, families, and business travelers. Passengers can travel conveniently to multiple destinations across Maharashtra and nearby states. Travelers benefit from smooth and reliable highway transportation."
},
{
name: "Intercity Cab Navi Mumbai",
description: "Intercity cab Navi Mumbai provides reliable road transportation between Navi Mumbai and other cities. The cab service is ideal for business travel, family trips, and tourism. Vehicles provide comfortable seating and smooth highway performance for long journeys. Professional drivers ensure punctual pickup and safe driving throughout the trip. Travelers enjoy convenient travel without the hassle of public transport. The service supports flexible travel schedules depending on passenger needs. Customers experience comfortable and dependable intercity transportation."
},
{
name: "Long Distance Taxi Navi Mumbai",
description: "Long distance taxi Navi Mumbai offers comfortable transportation for extended road journeys across cities and states. The taxi provides reliable vehicles suitable for long highway travel with spacious interiors. Professional drivers ensure safe driving and efficient route planning. Travelers can visit destinations like Goa, Ahmedabad, Indore, Hyderabad, and other cities comfortably. Vehicles provide strong AC cooling and smooth ride quality for relaxed travel. Families and groups enjoy convenient travel for extended trips. The service ensures dependable long-distance transportation."
},
{
name: "Navi Mumbai Outstation Taxi Booking",
description: "Navi Mumbai outstation taxi booking allows passengers to easily reserve vehicles for long-distance travel. Customers can book sedans, SUVs, or MPV vehicles depending on group size and travel requirements. Online and phone booking options provide quick confirmation for trips. Professional drivers ensure punctual pickup and safe driving during the journey. The service is ideal for family vacations, pilgrimage tours, and business travel. Vehicles provide comfortable interiors and smooth highway ride quality. Travelers enjoy convenient and reliable taxi booking services."
},
{
name: "Cheap Outstation Cab Navi Mumbai",
description: "Cheap outstation cab Navi Mumbai provides affordable intercity transportation for travelers looking for budget-friendly travel options. The service offers comfortable vehicles at economical rates without compromising safety or reliability. Professional drivers ensure punctual pickup services and smooth driving throughout the journey. The cab service is suitable for students, families, and daily travelers. Vehicles provide air-conditioned comfort and spacious seating for passengers. Travelers enjoy economical fares and convenient travel schedules. The service ensures reliable transportation at affordable prices."
},
{
name: "Best Outstation Taxi Navi Mumbai",
description: "Best outstation taxi Navi Mumbai provides premium transportation for travelers seeking reliable and comfortable long-distance travel. Vehicles offer spacious seating and smooth ride quality suitable for highway journeys. Professional drivers ensure safe driving and courteous service during the trip. The taxi service is ideal for corporate travel, family tours, and tourist journeys. Passengers enjoy air-conditioned comfort and dependable service. Flexible travel schedules make long-distance trips convenient. Customers benefit from high-quality and reliable transportation."
},
{
name: "Innova Outstation Cab Navi Mumbai",
description: "Innova outstation cab Navi Mumbai provides spacious MPV transportation ideal for families and groups traveling together. The Toyota Innova offers comfortable seating, strong AC cooling, and smooth highway performance. Professional drivers ensure safe driving and convenient pickups across Navi Mumbai. The vehicle provides ample luggage space for long journeys. Families and corporate travelers enjoy comfortable travel experiences. The service is perfect for long-distance trips and tourism travel. Travelers benefit from premium MPV comfort."
},
{
name: "Sedan Outstation Taxi Navi Mumbai",
description: "Sedan outstation taxi Navi Mumbai provides economical sedan transportation for long-distance travel. Vehicles like Swift Dzire and similar sedans offer comfortable seating and smooth ride quality for passengers. Professional drivers ensure safe driving and punctual pickups across Navi Mumbai. The service is ideal for small families, couples, and business travelers. Air-conditioned interiors ensure comfortable travel during long journeys. Travelers enjoy reliable and affordable intercity transportation. The service offers convenient and dependable sedan travel."
},
{
name: "SUV Outstation Cab Navi Mumbai",
description: "SUV outstation cab Navi Mumbai offers powerful and spacious vehicles suitable for long-distance travel and group transportation. SUVs provide comfortable seating, strong suspension, and smooth performance on highways. Professional drivers ensure safe driving and timely pickups from Navi Mumbai locations. The service is ideal for family trips, corporate travel, and tourism journeys. Vehicles provide ample luggage space and air-conditioned interiors for comfortable travel. Passengers enjoy reliable transportation for extended trips. The service ensures safe and comfortable SUV travel."
}
],

tableData: [
["Outstation Cab Service Navi Mumbai","Navi Mumbai Outstation Cab"],
["Outstation Taxi Navi Mumbai","Intercity Cab Navi Mumbai"],
["Long Distance Taxi Navi Mumbai","Navi Mumbai Outstation Taxi Booking"],
["Cheap Outstation Cab Navi Mumbai","Best Outstation Taxi Navi Mumbai"],
["Innova Outstation Cab Navi Mumbai","Sedan Outstation Taxi Navi Mumbai"],
["SUV Outstation Cab Navi Mumbai","Long Trip Taxi Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Outstation Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance travel from Navi Mumbai to various outstation destinations. They are familiar with major highways, hill routes, and intercity roads ensuring a safe and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Travel Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for outstation cab services in Navi Mumbai. Customers receive clear details about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our outstation cab service from Navi Mumbai operates 24 hours a day. Whether you want to start early morning or travel overnight, our cabs are available anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day outstation tour packages from Navi Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and residential societies anywhere in Navi Mumbai for a hassle-free start to your outstation journey."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for outstation cab bookings from Navi Mumbai thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide outstation cab service from Navi Mumbai?", answer: "Yes, Omshree Cabs provides reliable outstation cab services from Navi Mumbai to various cities and tourist destinations." },
  { question: "Which destinations are covered for outstation travel?", answer: "We provide outstation cabs from Navi Mumbai to destinations like Pune, Lonavala, Mahabaleshwar, Nashik, Shirdi, Goa, Kolhapur, and many other cities." },
  { question: "Can I book a one-way outstation cab?", answer: "Yes, we provide both one-way and round-trip outstation cab services from Navi Mumbai." },
  { question: "Which vehicles are available for outstation trips?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our outstation cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide airport pickup for outstation travel?", answer: "Yes, we provide airport pickup services from Navi Mumbai and Mumbai Airport for outstation journeys." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "We booked an outstation cab from Navi Mumbai to Mahabaleshwar with Omshree Cabs. The driver was punctual and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "Excellent outstation cab service from Navi Mumbai. Clean car, professional driver, and smooth long-distance travel.",
    rating: 5
  }
];







































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides reliable outstation cab services from Navi Mumbai. Travel comfortably to nearby cities or long-distance destinations with Innova, sedan, or SUV vehicles, ensuring safe and convenient trips.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Outstation Cab Service Navi Mumbai",
    "Navi Mumbai Outstation Taxi",
    "Intercity Cab Navi Mumbai",
    "Long Distance Taxi Navi Mumbai",
    "Innova Outstation Cab Navi Mumbai",
    "Sedan Outstation Taxi",
    "SUV Outstation Cab"
  ]
};






  return (
    <div>
      

<Helmet>
  <title>Outstation Cab Service Navi Mumbai | Omshree Cab</title>
  <meta
    name="description"
    content="Book a safe and comfortable outstation cab from Navi Mumbai with Omshree Cab. Choose from Innova, sedan, or SUV for intercity and long-distance trips, ensuring hassle-free travel."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcabservicenavimumbai;